import React from "react"

const Footer = () => {
  return (
    <div className="w-full">
      <div className="text-white py-6 bg-cortexx-50">
        <div className="flex flex-col md:flex-row md:justify-around md:items-start text-sm text-gray-400">
          <div className="hidden md:block text-slate-600 md:items-start md:justify-start">
            &copy; Cortexx Medical Intelligence 2025
          </div>
          <div className="flex justify-center items-center text-slate-600 ">
            <a href="https://cortexxmi.com">
              <span className="px-2">A propos</span>
            </a>
            <a href="https://cortexxmi.com/sumo/user-privacy/fr">
              <span className="px-2 border-l border-slate-600">
                Confidentialité
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
